import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { NativeFullScreenLayout } from '~/components/NativeFullScreenLayout/NativeFullScreenLayout';
export const NativeBootstrapRetryScreen = (param)=>{
    let { onRetry } = param;
    return /*#__PURE__*/ _jsx(NativeFullScreenLayout, {
        title: "Unable to connect",
        body: "Check your internet connection and try again.",
        action: {
            label: 'Retry',
            onClick: onRetry,
            biName: 'native_bootstrap_retry'
        }
    });
};
